import React, { Component } from 'react';
import { PageHeader, Panel } from 'react-bootstrap';
import {connect} from 'react-redux';
import moment from 'moment';

import { getApplication } from "../actions";
import { PROGRAM_ADN, PROGRAM_PT, statusTypes } from "../config/constants";

import Breadcrumbs from './Breadcrumbs';
import ApplicationStatus from './ApplicationStatus';
import BasicInfoSummary from './BasicInfoSummary';
import EducationInfoSummary from './EducationInfoSummary';
import ProfessionalSummary from "./ProfessionalSummary";
import OtherInfoSummary from "./OtherInfoSummary";
import PTRequirementsSummary from "./PTRequirementsSummary";
import PointsSummary from "./PointsSummary";

class Application extends Component {
  componentDidMount() {
    if(!this.props.isAuthenticated)
      this.props.history.push('/');
    else
    //  if(!this.props.applicationSet) {
        this.props.dispatch(getApplication(this.props.deltaId, this.props.match.params.applicationId));
    //  }
  }

  render() {
    const { basicInfo, educationInfo, professionalInfo, otherInfo, ptRequirementsInfo, applicationSet, application, period } = this.props;
    const applicationId = this.props.match.params.applicationId;
    const dateFormat = 'MMMM Do YYYY';
    let crumbs = [{
      text: "Home",
      url: "/"
    }, {
      text: "Applications",
      url: "/applications"
    }, {
      active: true,
      text: `${period ? period.name : ''} Application`,
      url: `/application/${applicationId}`
    }];
    return (
    <div>
      <Breadcrumbs crumbs={crumbs}/>

      <PageHeader>{period ? period.name : ''} Application</PageHeader>
      { applicationSet &&
        <ApplicationStatus />
      }
      { period &&
        <Panel header="Period Information" bsStyle={statusTypes.INFO}>
          <dl className="dl-horizontal">
          <dt>Period</dt>
          <dd>{period.name}</dd>
          <dt>Application Start Date</dt>
          <dd>{moment(period.applicationStartDate).format(dateFormat)}</dd>
          <dt>Application End Date</dt>
          <dd>{moment(period.applicationEndDate).format(dateFormat)}</dd>
          <dt>Notification Date</dt>
          <dd>{moment(period.notificationDate).format(dateFormat)}</dd>
          <dt>Documentation Due</dt>
          <dd>{moment(period.documentationDate).format(dateFormat)}</dd>
          <dt>Final Ranking Date</dt>
          <dd>{moment(period.rankingDate).format(dateFormat)}</dd>
          </dl>
        </Panel>
      }
      { applicationSet && application.points && application.programId === PROGRAM_ADN &&
        <PointsSummary />
      }
      <h4>Submitted Application</h4>
      { applicationSet && application.programId === PROGRAM_ADN &&
        <React.Fragment>
          <BasicInfoSummary {...basicInfo} withoutValidation={true} />
          <EducationInfoSummary {...educationInfo} withoutValidation={true} />
          <ProfessionalSummary {...professionalInfo} colleges={educationInfo.colleges} withoutValidation={true} />
          <OtherInfoSummary {...otherInfo} withoutValidation={true} />
        </React.Fragment>
      }
      { applicationSet && application.programId === PROGRAM_PT &&
      <React.Fragment>
        <BasicInfoSummary {...basicInfo} withoutValidation={true} />
        <EducationInfoSummary {...educationInfo} withoutValidation={true} />
        <PTRequirementsSummary {...ptRequirementsInfo} withoutValidation={true} />
      </React.Fragment>
      }
    </div>
  )
  };
}

function mapStateToProps(state) {
  const { auth, appInfo, basicInfo, educationInfo, professionalInfo, otherInfo, ptRequirementsInfo } = state;
  const { isAuthenticated, user } = auth;
  const { applicationPeriods, applicationSet, application } = appInfo;
  return {
    deltaId: user ? user.deltaId : '',
    isAuthenticated,
    period: applicationPeriods.find(period => period.periodId === application.periodId),
    applicationSet,
    application,
    basicInfo,
    educationInfo,
    professionalInfo,
    otherInfo,
    ptRequirementsInfo
  }
}

export default connect(mapStateToProps)(Application)